var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElasticSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(6 5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0BF1A",
    d: "M1.864759,10.422529 L26.461539,10.422529 C29.172169,10.422529 31.592639,9.179599 33.216729,7.239219 C29.828929,2.838589 24.511799,3.9e-05 18.528939,3.9e-05 C11.203179,3.9e-05 4.871919,4.252469 1.864759,10.422529"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07A5DE",
    d: "M24.376976,13.317694 L0.748176,13.317694 C0.264316,14.971424 2.6e-05,16.718884 2.6e-05,18.528874 C2.6e-05,20.338994 0.264316,22.086584 0.748176,23.740184 L24.376976,23.740184 C27.214226,23.740184 29.588286,21.424104 29.588286,18.528874 C29.588286,15.633774 27.272206,13.317694 24.376976,13.317694"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3EBEB0",
    d: "M33.279948,29.738124 C31.666128,27.841294 29.265158,26.635284 26.577278,26.635284 L1.864798,26.635284 C4.871958,32.805474 11.203218,37.057774 18.528848,37.057774 C24.548628,37.057774 29.895528,34.185164 33.279948,29.738124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M0.748215,13.317694 C0.264225,14.971424 6.5e-05,16.718884 6.5e-05,18.528874 C6.5e-05,20.338994 0.264225,22.086584 0.748215,23.740184 L16.212755,23.740184 C16.618095,22.176804 16.849625,20.439744 16.849625,18.528874 C16.849625,16.618134 16.618095,14.881074 16.212755,13.317694 L0.748215,13.317694 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7A229",
    d: "M9.206587,2.489864 C6.079697,4.342754 3.474107,7.122024 1.852877,10.422594 L15.517957,10.422594 C14.128257,7.237854 11.928007,4.574414 9.206587,2.489864"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#019B8F",
    d: "M9.78562,34.857511 C12.44906,32.715111 14.59146,29.877861 15.92331,26.635271 L1.85289,26.635271 C3.58995,30.109521 6.36935,33.004621 9.78562,34.857511"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticSearch);
export default __webpack_public_path__ + "static/media/ElasticSearch.19738468.svg";
export { ForwardRef as ReactComponent };